var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "buscador-container" }, [
    _c("div", { staticClass: "columns" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showFiltros,
              expression: "showFiltros",
            },
          ],
          staticClass: "column is-3",
        },
        [
          _c("filtros", {
            attrs: { query: _vm.query },
            on: {
              "update:query": function ($event) {
                _vm.query = $event
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "column" },
        [
          _c(
            "div",
            {
              staticClass:
                "columns is-vcentered is-variable is-1 is-mobile mb-0",
            },
            [
              _c("div", { staticClass: "column" }, [
                _c("div", { staticClass: "box search-box" }, [
                  _c("i", {
                    staticClass: "fas fa-filter float-filtro clickable",
                    class: { "has-text-primary": _vm.showFiltros },
                    on: { click: _vm.toggleFilters },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.inputSearch,
                        expression: "inputSearch",
                      },
                    ],
                    attrs: {
                      type: "text",
                      placeholder: "Escriba el nombre del documento",
                    },
                    domProps: { value: _vm.inputSearch },
                    on: {
                      keyup: _vm.filterDocuments,
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.inputSearch = $event.target.value
                      },
                    },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "column is-narrow" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "button is-primary search-button is-radiusless",
                    on: { click: _vm.filterDocuments },
                  },
                  [
                    _c("i", {
                      staticClass: "search-icon",
                      class: _vm.iconsToggleLoading,
                    }),
                  ]
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "columns is-vcentered is-variable is-1 is-mobile is-justify-content-end",
            },
            [
              _c(
                "b-tooltip",
                {
                  attrs: {
                    position: "is-left",
                    active: !_vm.downloadSearchResultEnabled,
                    label: "Debe hacer una búsqueda primero",
                  },
                },
                [
                  this.searchResult.length
                    ? _c(
                        "b-button",
                        {
                          staticClass: "mt-2 mr-1",
                          attrs: {
                            disabled: !_vm.downloadSearchResultEnabled,
                            "icon-right": "fas fa-file-pdf",
                            size: "is-small",
                            type: "is-primary",
                            outlined: "",
                          },
                          on: { click: _vm.openDownloadNameModal },
                        },
                        [_vm._v("Descargar")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.searchResult, function (res) {
            return _c(
              "div",
              {
                key: res.id,
                staticClass: "box my-2",
                class: {
                  "is-selected": _vm.selectedFile == res.id,
                  "p-0": _vm.settings.showThumbnails,
                  "py-3 px-4": !_vm.settings.showThumbnails,
                },
                on: {
                  click: function ($event) {
                    _vm.selectedFile = res.id
                  },
                  dblclick: function ($event) {
                    return _vm.dobleClick(res)
                  },
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "media result is-align-items-center" },
                  [
                    _c("div", { staticClass: "media-left" }, [
                      !_vm.settings.showThumbnails
                        ? _c("i", {
                            staticClass: "is-size-4",
                            class: _vm.getDocumentIcon(res),
                          })
                        : _c("div", [
                            res.tipo_documento_id == "carpeta"
                              ? _c("div", {
                                  staticClass: "thumbnail center",
                                  style: `background-image: url('/statics/default-folder.png')`,
                                })
                              : _c("div", {
                                  staticClass: "thumbnail",
                                  class: { center: !res.preview_uri },
                                  style: `background-image: url(${
                                    res.preview_uri
                                      ? res.preview_uri
                                      : "/statics/default-document.png"
                                  })`,
                                }),
                          ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "media-content pr-2",
                        class: { "": _vm.settings.showThumbnails },
                      },
                      [
                        _c("h1", { staticClass: "title is-6" }, [
                          _vm._v(_vm._s(res.nombre)),
                        ]),
                        _vm._v(" "),
                        _c("h2", { staticClass: "subtitle is-7" }, [
                          _vm._v(_vm._s(res.ruta)),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "media-right px-3" }, [
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.dobleClick(res)
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "fas fa-angle-double-right fa-lg",
                          }),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]
            )
          }),
          _vm._v(" "),
          _c(
            "infinite-loading",
            {
              attrs: { identifier: _vm.infiniteLoaderIdentifier },
              on: { infinite: _vm.infiniteHandler },
            },
            [
              _c(
                "div",
                {
                  staticClass: "section",
                  attrs: { slot: "no-more" },
                  slot: "no-more",
                },
                [
                  _c("span", { staticClass: "is-mono" }, [
                    _c("i", { staticClass: "far fa-surprise" }),
                    _c("br"),
                    _vm._v("Fin de los resultados"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "section",
                  attrs: { slot: "no-results" },
                  slot: "no-results",
                },
                [
                  _c("span", { staticClass: "is-mono" }, [
                    _c("i", { staticClass: "far fa-surprise" }),
                    _c("br"),
                    _vm._v("Fin de los resultados"),
                  ]),
                ]
              ),
            ]
          ),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }